module.exports = __webpack_public_path__ + "images/assets/7c8407130b282f4e9e15a2f0034afef0.svg";